import React from "react";
import { useMetrus } from "shared/providers";

const AutoComplete = ({ onChange }) => {
  const {
    setLatGoogle,
    setLongGoogle,
    setProviderId,
    setSpecialistId,
    setRegionName,
    setNeighId,
    setDisabledNeigh,
    setDisabledCity,
    setState,
    setCityId,
    setNameProviderId,
    setPreferr,
  } = useMetrus();

  const autoCompleteRef = React.useRef();
  const inputRef = React.useRef();

  const options = {
    componentRestrictions: { country: "br" },
    fields: ["geometry"],
    types: ["address"],
  };

  React.useEffect(() => {
    autoCompleteRef.current = new window.google.maps.places.Autocomplete(
      inputRef.current,
      options
    );

    autoCompleteRef.current.addListener("place_changed", async function () {
      const place = await autoCompleteRef.current.getPlace();

      if (place.geometry && place.geometry.location) {
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();

        console.log(`Latitude: ${lat}, Longitude: ${lng}`);

        setLatGoogle(lat);
        setLongGoogle(lng);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{ paddingBottom: "20px" }}>
      <input
        className="input-autocomplete"
        ref={inputRef}
        placeholder="Digite o endereço desejado"
        onChange={() => {
          setProviderId("");
          setSpecialistId("");
          setRegionName("");
          setNeighId("");
          setDisabledNeigh(true);
          setDisabledCity(true);
          setState("");
          setCityId("");
          setNameProviderId("");
          setPreferr("TYPE");
          onChange();
        }}
      />
    </div>
  );
};

export default AutoComplete;
